import { NgModule } from '@angular/core'
import { ConfirmDialogComponent } from './confirm-dialog.component'
import { MatDialogModule } from '@angular/material/dialog';
import {FormsModule} from '@angular/forms'
import {CommonModule} from '@angular/common'

@NgModule({
    declarations: [
        ConfirmDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
    ],
    exports: [ConfirmDialogComponent],
    providers: []
})
export class ConfirmDialogModule {}
